module.exports = {
      id: "icon-social-linkedIn-share-usage",
      viewBox: "0 0 25 24",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-social-linkedIn-share",
      toString: function () {
        return this.url;
      }
    }